module.exports = __webpack_public_path__ + "img/heart.5a113f1a.svg";